import { render, staticRenderFns } from "./new-blood-oxygen-report.vue?vue&type=template&id=46172083&scoped=true"
import script from "./new-blood-oxygen-report.vue?vue&type=script&lang=js"
export * from "./new-blood-oxygen-report.vue?vue&type=script&lang=js"
import style0 from "./new-blood-oxygen-report.vue?vue&type=style&index=0&id=46172083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46172083",
  null
  
)

export default component.exports